import React from 'react';
import PropTypes from 'prop-types';

const Padlock = ({ padlock_text: padlockText }) => (
  <div className="smartbanner-padlock">
    <div className="padlock" />
    {
      padlockText && padlockText !== ''
      && (
      <span className="padlock-text">
        {padlockText}
      </span>
      )
    }
  </div>
);

Padlock.propTypes = {
  padlock_text: PropTypes.string.isRequired,
};

export default Padlock;
